import { __extends } from "tslib";
import { DeletePushTemplateRequest, DeletePushTemplateResponse } from "../models/models_0";
import { deserializeAws_restJson1DeletePushTemplateCommand, serializeAws_restJson1DeletePushTemplateCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var DeletePushTemplateCommand = /** @class */ (function (_super) {
    __extends(DeletePushTemplateCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeletePushTemplateCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    DeletePushTemplateCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "PinpointClient";
        var commandName = "DeletePushTemplateCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: DeletePushTemplateRequest.filterSensitiveLog,
            outputFilterSensitiveLog: DeletePushTemplateResponse.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeletePushTemplateCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1DeletePushTemplateCommand(input, context);
    };
    DeletePushTemplateCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1DeletePushTemplateCommand(output, context);
    };
    return DeletePushTemplateCommand;
}($Command));
export { DeletePushTemplateCommand };
//# sourceMappingURL=DeletePushTemplateCommand.js.map